// import React, { useEffect, useState } from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   Form,
//   FormFeedback,
//   Input,
//   Label,
//   Row,
//   Col,
// } from "reactstrap";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import toast from "react-hot-toast";
// // import InvoiceServices from "../../../Services/InvoiceServices/InvoiceServices";
// import PaymentLogServices from "../../../Services/QRCodeServices/PaymentLogServices/PaymentLogServices";
// import SupplierServices from "../../../Services/QRCodeServices/SupplierServices/SupplierServices";

// const PaymentAddEditModal = ({
//   isOpen,
//   toggle,
//   isEdit,
//   selectedPaymentLog,
//   onSuccess,
// }) => {
//   const [suppliers, setSuppliers] = useState([]);
//   const [invoices, setInvoices] = useState([]);

//   // Validation schema using Yup
//   const validationSchema = Yup.object({
//     supplierId: Yup.number()
//       .min(1, "Please select a supplier")
//       .required("Supplier is required"),

//     paidAmount: Yup.number()
//       .min(0, "Paid Amount cannot be negative")
//       .required("Paid Amount is required"),
//     paymentDate: Yup.date().required("Payment Date is required"),
//     paymentMethod: Yup.string().required("Payment Method is required"),
//     remarks: Yup.string(),
//   });

//   // Formik setup
//   const formik = useFormik({
//     initialValues: {
//       supplierId: selectedPaymentLog?.supplierId || "",
//       invoiceId: selectedPaymentLog?.invoiceId || "",
//       paidAmount: selectedPaymentLog?.paidAmount || 0,
//       paymentDate:
//         selectedPaymentLog?.paymentDate ||
//         new Date().toISOString().split("T")[0],

//       paymentMethod: selectedPaymentLog?.paymentMethod || "",
//       remarks: selectedPaymentLog?.remarks || "",
//     },
//     validationSchema: validationSchema,
//     enableReinitialize: true,

//     onSubmit: async (values) => {
//       try {
//         const payload = {
//           id: isEdit ? selectedPaymentLog.id : undefined,
//           supplierId: Number(values.supplierId),
//           invoiceId: Number(values.invoiceId),
//           paidAmount: Number(values.paidAmount),
//           paymentDate: values.paymentDate,
//           paymentMethod: values.paymentMethod,
//           remarks: values.remarks,
//         };

//         if (isEdit) {
//           await PaymentLogServices.update(selectedPaymentLog.id, payload);
//           toast.success("Payment log updated successfully!");
//         } else {
//           await PaymentLogServices.create(payload);
//           toast.success("Payment log created successfully!");
//         }
//         onSuccess();
//         formik.resetForm();
//       } catch (error) {
//         toast.error(error.response?.data || "Failed to save payment log");
//         console.error("Error saving payment log:", error);
//       }
//     },
//   });

//   const handleCancel = () => {
//     formik.resetForm();
//     toggle();
//   };

//   const fetchSuppliers = async () => {
//     try {
//       const response = await SupplierServices.getList();
//       setSuppliers(response.data);
//     } catch (error) {
//       console.error("Error fetching suppliers:", error);
//     }
//   };

//   const fetchInvoices = async () => {
//     try {
//       const response = await InvoiceServices.getList();
//       setInvoices(response);
//     } catch (error) {
//       console.error("Error fetching invoices:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSuppliers();
//     fetchInvoices();
//   }, []);

//   return (
//     <Modal isOpen={isOpen} toggle={toggle}>
//       <ModalHeader toggle={handleCancel}>
//         {isEdit ? "Edit Payment Log" : "Create Payment Log"}
//       </ModalHeader>
//       <Form onSubmit={formik.handleSubmit}>
//         <ModalBody>
//           <Row>
//             <Col md={12} className="mb-3">
//               <Label for="supplierId">Supplier</Label>
//               <Input
//                 type="select"
//                 id="supplierId"
//                 name="supplierId"
//                 onChange={(e) =>
//                   formik.setFieldValue("supplierId", Number(e.target.value))
//                 }
//                 onBlur={formik.handleBlur}
//                 value={formik.values.supplierId}
//                 invalid={formik.touched.supplierId && formik.errors.supplierId}
//               >
//                 <option value="">Select a supplier</option>
//                 {suppliers.map((supplier) => (
//                   <option key={supplier.id} value={supplier.id}>
//                     {supplier.supplierName}
//                   </option>
//                 ))}
//               </Input>
//               {formik.touched.supplierId && formik.errors.supplierId && (
//                 <FormFeedback>{formik.errors.supplierId}</FormFeedback>
//               )}
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12} className="mb-3">
//               <Label for="invoiceId">Invoice ID</Label>
//               <Input
//                 type="number"
//                 id="invoiceId"
//                 name="invoiceId"
//                 placeholder="Enter Invoice ID"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.invoiceId}
//                 invalid={formik.touched.invoiceId && formik.errors.invoiceId}
//               />
//               {formik.touched.invoiceId && formik.errors.invoiceId && (
//                 <FormFeedback>{formik.errors.invoiceId}</FormFeedback>
//               )}
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12} className="mb-3">
//               <Label for="paidAmount">Paid Amount</Label>
//               <Input
//                 type="number"
//                 id="paidAmount"
//                 name="paidAmount"
//                 placeholder="Enter Paid Amount"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.paidAmount}
//                 invalid={formik.touched.paidAmount && formik.errors.paidAmount}
//               />
//               {formik.touched.paidAmount && formik.errors.paidAmount && (
//                 <FormFeedback>{formik.errors.paidAmount}</FormFeedback>
//               )}
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12} className="mb-3">
//               <Label for="paymentDate">Payment Date</Label>
//               <Input
//                 type="date"
//                 id="paymentDate"
//                 name="paymentDate"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.paymentDate}
//                 invalid={
//                   formik.touched.paymentDate && formik.errors.paymentDate
//                 }
//               />
//               {formik.touched.paymentDate && formik.errors.paymentDate && (
//                 <FormFeedback>{formik.errors.paymentDate}</FormFeedback>
//               )}
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12} className="mb-3">
//               <Label for="paymentMethod">Payment Method</Label>
//               <Input
//                 type="text"
//                 id="paymentMethod"
//                 name="paymentMethod"
//                 placeholder="Enter Payment Method"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.paymentMethod}
//                 invalid={
//                   formik.touched.paymentMethod && formik.errors.paymentMethod
//                 }
//               />
//               {formik.touched.paymentMethod && formik.errors.paymentMethod && (
//                 <FormFeedback>{formik.errors.paymentMethod}</FormFeedback>
//               )}
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12} className="mb-3">
//               <Label for="remarks">Remarks</Label>
//               <Input
//                 type="textarea"
//                 id="remarks"
//                 name="remarks"
//                 placeholder="Enter Remarks"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.remarks}
//                 invalid={formik.touched.remarks && formik.errors.remarks}
//               />
//               {formik.touched.remarks && formik.errors.remarks && (
//                 <FormFeedback>{formik.errors.remarks}</FormFeedback>
//               )}
//             </Col>
//           </Row>
//         </ModalBody>
//         <ModalFooter>
//           <Button type="submit" color="success" disabled={formik.isSubmitting}>
//             {isEdit ? "Update" : "Save"}
//           </Button>
//           <Button color="danger" onClick={handleCancel} type="button">
//             Cancel
//           </Button>
//         </ModalFooter>
//       </Form>
//     </Modal>
//   );
// };

// export default PaymentAddEditModal;

import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Select from "react-select";
// import InvoiceServices from "../../../Services/InvoiceServices/InvoiceServices";
import PaymentLogServices from "../../../Services/QRCodeServices/PaymentLogServices/PaymentLogServices";
import SupplierServices from "../../../Services/QRCodeServices/SupplierServices/SupplierServices";

const PaymentAddEditModal = ({
  isOpen,
  toggle,
  isEdit,
  selectedPaymentLog,
  onSuccess,
}) => {
  const [suppliers, setSuppliers] = useState([]);
  const [invoices, setInvoices] = useState([]);

  // Payment method options for react-select
  const paymentMethodOptions = [
    { value: 1, label: "Bank" },
    { value: 2, label: "Cash" },
    { value: 3, label: "Online Payment" },
  ];

  // Validation schema using Yup
  const validationSchema = Yup.object({
    supplierId: Yup.number()
      .min(1, "Please select a supplier")
      .required("Supplier is required"),
    paidAmount: Yup.number()
      .min(0, "Paid Amount cannot be negative")
      .required("Paid Amount is required"),
    paymentDate: Yup.date().required("Payment Date is required"),
    paymentMethod: Yup.number()
      .oneOf([1, 2, 3], "Please select a valid payment method")
      .required("Payment Method is required"),
    remarks: Yup.string(),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      supplierId: selectedPaymentLog?.supplierId || "",
      invoiceId: selectedPaymentLog?.invoiceId || "",
      paidAmount: selectedPaymentLog?.paidAmount || 0,
      paymentDate:
        selectedPaymentLog?.paymentDate ||
        new Date().toISOString().split("T")[0],
      paymentMethod: selectedPaymentLog?.paymentMethod || "",
      remarks: selectedPaymentLog?.remarks || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        const payload = {
          id: isEdit ? selectedPaymentLog.id : undefined,
          supplierId: Number(values.supplierId),
          invoiceId: Number(values.invoiceId),
          paidAmount: Number(values.paidAmount),
          paymentDate: values.paymentDate,
          paymentMethod: Number(values.paymentMethod),
          remarks: values.remarks,
        };

        if (isEdit) {
          await PaymentLogServices.update(selectedPaymentLog.id, payload);
          toast.success("Payment log updated successfully!");
        } else {
          await PaymentLogServices.create(payload);
          toast.success("Payment log created successfully!");
        }
        onSuccess();
        formik.resetForm();
      } catch (error) {
        toast.error(error.response?.data || "Failed to save payment log");
        console.error("Error saving payment log:", error);
      }
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    toggle();
  };

  const fetchSuppliers = async () => {
    try {
      const response = await SupplierServices.getList();
      setSuppliers(response.data);
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
  };

  const fetchInvoices = async () => {
    try {
      const response = await InvoiceServices.getList();
      setInvoices(response);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  useEffect(() => {
    fetchSuppliers();
    fetchInvoices();
  }, []);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={handleCancel}>
        {isEdit ? "Edit Payment Log" : "Create Payment Log"}
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Row>
            <Col md={12} className="mb-3">
              <Label for="supplierId">Supplier</Label>
              <Input
                type="select"
                id="supplierId"
                name="supplierId"
                onChange={(e) =>
                  formik.setFieldValue("supplierId", Number(e.target.value))
                }
                onBlur={formik.handleBlur}
                value={formik.values.supplierId}
                invalid={formik.touched.supplierId && formik.errors.supplierId}
              >
                <option value="">Select a supplier</option>
                {suppliers.map((supplier) => (
                  <option key={supplier.id} value={supplier.id}>
                    {supplier.supplierName}
                  </option>
                ))}
              </Input>
              {formik.touched.supplierId && formik.errors.supplierId && (
                <FormFeedback>{formik.errors.supplierId}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-3">
              <Label for="invoiceId">Invoice ID</Label>
              <Input
                type="number"
                id="invoiceId"
                name="invoiceId"
                placeholder="Enter Invoice ID"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.invoiceId}
                invalid={formik.touched.invoiceId && formik.errors.invoiceId}
              />
              {formik.touched.invoiceId && formik.errors.invoiceId && (
                <FormFeedback>{formik.errors.invoiceId}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-3">
              <Label for="paidAmount">Paid Amount</Label>
              <Input
                type="number"
                id="paidAmount"
                name="paidAmount"
                placeholder="Enter Paid Amount"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.paidAmount}
                invalid={formik.touched.paidAmount && formik.errors.paidAmount}
              />
              {formik.touched.paidAmount && formik.errors.paidAmount && (
                <FormFeedback>{formik.errors.paidAmount}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-3">
              <Label for="paymentDate">Payment Date</Label>
              <Input
                type="date"
                id="paymentDate"
                name="paymentDate"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.paymentDate}
                invalid={
                  formik.touched.paymentDate && formik.errors.paymentDate
                }
              />
              {formik.touched.paymentDate && formik.errors.paymentDate && (
                <FormFeedback>{formik.errors.paymentDate}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-3">
              <Label for="paymentMethod">Payment Method</Label>
              <Select
                id="paymentMethod"
                name="paymentMethod"
                options={paymentMethodOptions}
                onChange={(option) =>
                  formik.setFieldValue(
                    "paymentMethod",
                    option ? option.value : ""
                  )
                }
                onBlur={() => formik.setFieldTouched("paymentMethod", true)}
                value={paymentMethodOptions.find(
                  (option) => option.value === formik.values.paymentMethod
                )}
                placeholder="Select Payment Method"
                isClearable
                className={
                  formik.touched.paymentMethod && formik.errors.paymentMethod
                    ? "is-invalid"
                    : ""
                }
              />
              {formik.touched.paymentMethod && formik.errors.paymentMethod && (
                <FormFeedback>{formik.errors.paymentMethod}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-3">
              <Label for="remarks">Remarks</Label>
              <Input
                type="textarea"
                id="remarks"
                name="remarks"
                placeholder="Enter Remarks"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.remarks}
                invalid={formik.touched.remarks && formik.errors.remarks}
              />
              {formik.touched.remarks && formik.errors.remarks && (
                <FormFeedback>{formik.errors.remarks}</FormFeedback>
              )}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="success" disabled={formik.isSubmitting}>
            {isEdit ? "Update" : "Save"}
          </Button>
          <Button color="danger" onClick={handleCancel} type="button">
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default PaymentAddEditModal;
